import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Asset} from 'common/src/modules/Assets/Assets.types';
import {BrandAssetsState} from './brandAssets.types';

const initialState: BrandAssetsState = {
  images: null,
  videos: null,
};

const brandAssetsSlice = createSlice({
  name: 'brandAssets',
  initialState,
  reducers: {
    clearBrandImages: (state) => {
      state.images = null;
    },
    clearBrandVideos: (state) => {
      state.videos = null;
    },
    clearAllBrandAssets: (state) => {
      state.images = null;
      state.videos = null;
    },
    setBrandImages: (state, action: PayloadAction<Asset[]>) => {
      state.images = action.payload;
    },
    setBrandVideos: (state, action: PayloadAction<Asset[]>) => {
      state.videos = action.payload;
    },
  },
});

export const {
  clearBrandImages,
  clearBrandVideos,
  clearAllBrandAssets,
  setBrandImages,
  setBrandVideos,
} = brandAssetsSlice.actions;

export default brandAssetsSlice.reducer;
